var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#00B4D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 48V0C34.7822 0 22.8158 5.46755 14.1538 14.1538L48 48Z",
    fill: "#F72585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48H0C0 34.7822 5.46755 22.8158 14.1538 14.1538L48 48Z",
    fill: "#B5179E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48H0C0 61.2178 5.46755 73.1842 14.1538 81.8462L48 48Z",
    fill: "#7209B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48V96C34.7822 96 22.8158 90.5324 14.1538 81.8462L48 48Z",
    fill: "#560BAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48V96C61.2178 96 73.1842 90.5324 81.8462 81.8462L48 48Z",
    fill: "#3B009A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartGraphic);
export default __webpack_public_path__ + "static/media/chart-graphic.61654d81bd84bf878a0d0894282a5e77.svg";
export { ForwardRef as ReactComponent };